import styled from 'styled-components';

interface CharCountProps {
  state: 'normal' | 'warning' | 'exceeded';
}

export const FieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;
`;

export const CharCount = styled.span<CharCountProps>`
  font-size: 11px;
  margin-top: 4px;
  text-align: right;
  transition: color 0.2s ease;

  color: ${({ state }) => {
    if (state === 'exceeded') return '#ec3237';
    if (state === 'warning') return '#e07b00';
    return '#9a9a9a';
  }};
`;

export const LimitWarning = styled.span`
  font-size: 11px;
  margin-top: 2px;
  color: #e07b00;
  animation: fadeIn 0.25s ease;

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(-4px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;
